// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".velocity-verification-Select-wrapper {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-flex-basis: 100%;\n          flex-basis: 100%;\n}\n.velocity-verification-Select-select {\n  max-width: 100%;\n}\n", ""]);
// Exports
exports.locals = {
	"wrapper": "velocity-verification-Select-wrapper",
	"select": "velocity-verification-Select-select"
};
module.exports = exports;
